"use client"

import { useQuery } from "convex/react"
import { api } from "@/convex/_generated/api"
import { MultiStepIdeaForm } from "@/components/multi-step-idea-form"
import { Loader2 } from "lucide-react"

export default function Page() {
  // Fetch examples from Convex with real-time updates
  const examples = useQuery(api.examples.getAll)
  
  // Fetch showcase projects from Convex with real-time updates
  const showcaseProjects = useQuery(api.showcase.getAllWithUrls)

  if (examples === undefined || showcaseProjects === undefined) {
    // Still loading
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Loader2 className="h-12 w-12 animate-spin text-zinc-500" />
      </div>
    )
  }

  // Structure examples data
  const initialExamples = {
    product: examples?.product || [],
    action: examples?.action || [],
    customer: examples?.customer || []
  }

  return <MultiStepIdeaForm 
    initialExamples={initialExamples} 
    showcaseProjects={showcaseProjects || []} 
  />
}